import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Sidenav from '../Sidenav/Sidenav';
import AddUserModal from './AddUserModal';
import DeleteConfirmationModal from './DeleteUser';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import correct from '../../src/assets/correct.png';
import wrong from '../../src/assets/wrong.png';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonAddRoundedIcon from '@mui/icons-material/PersonAddRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Box from '@mui/material/Box';
import { CircularProgress } from "@mui/material";
import { Menu, MenuItem, IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import Toast from '../global/toastmessage'
import SideNavLayout from '../Sidenav/SideNavLayout';
const Users = () => {
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fullNames, setFullNames] = useState("");
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success' 
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleMenuOpen = (event, device) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(device);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const showToast = (message, severity = 'success') => {
    setToast({
      open: true,
      message,
      severity
    });
  };

  const handleCloseToast = () => {
    setToast(prev => ({ ...prev, open: false }));
  };

  const token = sessionStorage.getItem("accessToken");

  
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get("/v1/users/active");
      if (response.data && Array.isArray(response.data)) {
        // Map the response to ensure we have the correct user_id structure
        const formattedUsers = response.data.map(user => ({
          ...user,
          // Extract user_id based on your API response structure
          id: user.id || user.details?.user_id || user.user_id
        }));
          formattedUsers.sort((a, b) => {
    if (a.status === "I" && b.status !== "I") return 1;   // move a down
    if (a.status !== "I" && b.status === "I") return -1;  // move b down
    return 0; // otherwise keep order
  });
        setUsers(formattedUsers);
      }
    } catch (error) {
      // error handling
    } finally {
      setLoading(false);
    }
  };

  const handleUsernameClick = (user) => {
    setCurrentUser({
      ...user,
      id: user.id || user.details?.user_id || user.user_id
    });
    setIsModalOpen(true);
  };

    useEffect(() => {
      fetchUsers();
    }, [token]);

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleEdit = (user) => {
    // Make sure we're passing the correct user_id
    setCurrentUser({
      ...user,
      id: user.id || user.details?.user_id || user.user_id
    });
    setIsModalOpen(true);
  };

  const handleDelete = (user) => {
    // Make sure we're passing the correct user_id
    setCurrentUser({
      ...user,
      id: user.id || user.details?.user_id || user.user_id
    });
    setFullNames(`${user.firstname} ${user.lastname}`);
    setIsDeleteModalOpen(true);
  };

 

  const deleteUser = async () => {
    try {
      const userId = currentUser.id || currentUser.details?.user_id || currentUser.user_id;
      const response = await api.delete(`/v1/users/${userId}`);
      
      await fetchUsers();
      setUsers(users.filter(user => user.user_id !== currentUser.user_id));
      setIsDeleteModalOpen(false);
      setCurrentUser(null);
      showToast(response.data?.message || 'User deleted successfully');
    } catch (error) {
      console.error('Failed to delete user:', error);
      showToast(error.response?.data?.message || 'Failed to delete user', 'error');
    }
  };



  const handleSaveUser = async (responseData, isEditMode) => {
    await fetchUsers();
    setCurrentUser(null);
    showToast(
      responseData?.message || 
      (isEditMode ? 'User updated successfully' : 'User created successfully')
    );
  };

  

  return (
<SideNavLayout>
      <div className='w-full max-h-[90vh] overflow-y-auto  p-8' style={{scrollbarWidth:'none'}}>
        <div className='flex justify-center gap-2 items-center mb-6 '>
          <button onClick={() => navigate('/dashboard')} className='bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm font-inter'>
            <HomeRoundedIcon style={{width:"20px"}}/> Home
          </button>
          <button  onClick={() => setIsModalOpen(true)} className='bg-[#145388] flex items-center gap-1 text-white px-3 py-1 rounded-md text-sm font-inter' >
            <PersonAddRoundedIcon style={{width:"20px"}}/> Add User
          </button>
        </div>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <div className="text-red-500 text-center p-4">Error loading users: {error}</div>
        ) : (

<div className='bg-white w-[100%] mx-auto  rounded-lg'>
  <div className=' overflow-x-auto scrollbar-thin border  rounded-lg p-4'>
             <table className='w-full table-auto border-collapse '>
  
         <thead className='bg-[#eee] text-left text-gray-700 uppercase text-sm '>
              <tr className='text-xs'>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Username</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400  '>Email</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Phone</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>iPad ID</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Last Login</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Last Logout</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Status</th>
                <th className='py-3 px-4 font-Font1 font-semibold text-red-800 text-gray-400 '>Action</th>
              </tr>
            </thead>
            <tbody className='overflow-y-auto custom-scrollbar max-h-[500px]'>
              {users.map((user, index) => (
                <tr key={user.id} className='border-t relative py-3'>
                  <td className='py-2 px-2' align='left'>
                    <button  onClick={() => handleUsernameClick(user)}
                           className='bg-gray-50 border text-[13px] font-inter text-[#374151] px-3 py-1 rounded-md'>
                    {`${user.firstname} ${user.lastname}`}   
                       <KeyboardArrowRightRoundedIcon fontSize="small" />
                    </button>
                  </td>
                  <td  className='py-[11.2px] text-[14px]  px-[12px] text-left font-inter text-[#374151]'>{user.email}</td>
                  <td className='py-2  text-[14px] text-[#374151] pl-4 pr-2 font-inter' align='left'>{user.phone}</td>
                  <td className='py-2 text-[14px] text-[#374151] pl-4 pr-2 font-inter' align='left  '>{user.ipadid || '-'}</td>
                  <td className='py-2 text-[14px] text-[#374151] pl-4 pr-2 font-inter' align='left'>{user.lastlogin ? moment(user.lastlogin).format('MM-DD-YYYY hh:mm:ss A') : '-'}</td>
                  <td className='py-2 text-[14px] text-[#374151] pl-4 pr-2 font-inter' align='left'>{user.lastlogout ? moment(user.lastlogout).format('MM-DD-YYYY hh:mm:ss A') : '-'}</td>
                  <td className='py-2 text-[14px] text-[#374151] pl-4 pr-2 font-inter '  align='left'>
                    {user.status === 'A' ? (
                      <img src={correct} alt="Active" className="h-4 w-4  ml-2" />
                    ) : (
                      <img src={wrong} alt="Inactive" className="h-4 w-4  ml-2" />
                    )}
                  </td>
                  <td className="py-2 px-2" align="left">
      <button
  onClick={(e) => handleMenuOpen(e, user)}
  className="bg-transparent text-[14px] text-[#374151] font-inter px-2 py-1 rounded-md"
      >
        Actions <KeyboardArrowDownRoundedIcon />
      </button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          elevation: 1, // Reduce default elevation
          sx: {
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.15)', // Subtle custom shadow
            borderRadius: '8px'
          }
        }}
      >
        <MenuItem style={{fontSize:"14px"}}
          onClick={() => {
            handleEdit(selectedUser);
            handleMenuClose();
          }}
        >
          <EditIcon style={{color:"gray"}} fontSize="small"  className="mr-2" /> Edit
        </MenuItem>
        <MenuItem style={{fontSize:"14px"}}
          onClick={() => {
            handleDelete(selectedUser);
            handleMenuClose();
          }}
        >
          <DeleteIcon style={{color:"red"}} fontSize="small" className="mr-2" /> Delete
        </MenuItem>
      </Menu>
    </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>

        </div>

          )}

        <AddUserModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setCurrentUser(null);
        }}
        onSave={handleSaveUser}
        // onSave={fetchUsers} 
        editUser={currentUser}
        showToast={showToast}
      />
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onConfirm={deleteUser}
          deleteConfirm ={fullNames}
        />
         <Toast
          open={toast.open}
          onClose={handleCloseToast}
          severity={toast.severity}
          message={toast.message}
        />
      </div>
</SideNavLayout>
  );
};

export default Users;